<template>
  <div id="bg-overlay">
    <Header />
    <Sidebar />
    <v-main app>
      <v-container class="px-3 px-sm-6" fluid>
        <router-view />
        <v-sheet color="transparent" :height="`calc(${footerHeight} + 40px)`" />
      </v-container>
      <Footer />
    </v-main>
  </div>
</template>

<script>
let timeout = null;
export default {
  mounted() {
    this.checkSession();
  },

  beforeDestroy() {
    clearTimeout(timeout);
  },

  methods: {
    async checkSession() {
      const response = await this.$http.get('auth/check-session');
      if (response.status !== 'OK') {
        this.$store.commit('logout');
        return;
      }
      timeout = setTimeout(() => {
        this.checkSession();
      }, 6 * 1000); // 1 minutes
    }
  },

  components: {
    Header: () => import(`@/variants/${process.env.VUE_APP_VARIANT}/components/layout/Header.vue`),
    Footer: () => import(`@/variants/${process.env.VUE_APP_VARIANT}/components/layout/Footer.vue`),
    Sidebar: () => import(`@/variants/${process.env.VUE_APP_VARIANT}/components/layout/Sidebar.vue`),
  },

  computed: {
    headerHeight() {
      return `${process.env.VUE_APP_HEADER_HEIGHT}px`;
    },

    footerHeight() {
      return `${process.env.VUE_APP_FOOTER_HEIGHT}px`;
    },

    containerHeight() {
      return `calc(100vh - ${this.headerHeight})`;
    },

    contentHeight() {
      return `calc(100vh - ${this.headerHeight} - ${this.footerHeight})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  position: relative;
  // min-height: 100vh;
  // max-height: 100vh;
}

#scroll-container {
  position: relative;
  overflow: auto;
}

.v-main {
  min-height: 100vh;
  // overflow: auto;
  // overflow: auto;
  position: relative;

  // height: 100vh !important;
  //   min-height: 100vh;
  //   max-height: 100vh;
  //   overflow: auto;
}

footer {
  position: absolute;
  left: 0 !important;
  bottom: 0px !important;
  z-index: 0;
}

// ::-webkit-scrollbar-track {
//   margin-top: 640px;
// }
</style>
